const HUES = [262, 210, 150, 28, 340, 190];

export function initials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

export function avatarHue(name: string): number {
  return HUES[(name.charCodeAt(0) + name.length) % HUES.length];
}
